import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Card, Row, Col } from "react-bootstrap";
import Layout from "../../../layout/default";
import Block from "../../../components/Block/Block";
import { Icon } from "../../../components";
import api from "../../../services/auth/api";

// const baseURL = process.env.SSP_BASE_URL_BACKEND;

// const baseURL = "http://127.0.0.1:8000/api/";

function ProductView() {
  const styles = {
    ctstyle: {
      backgroundColor: "rgb(248, 248, 249, 1)",
      color: "rgb(0, 0, 0)",
      width: "50%",
    },
  };

  const { id } = useParams();
  const [stateData, setStateData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getIdList = () => {
    setLoading(true);
    api
      .get(`${process.env.REACT_APP_HOST}api/product-variant/${id}`)
      .then((response) => {
        debugger;
        if(response.data.success) {
            setStateData(response.data.data[0]);
        }
        
      })
      .catch((err) => {
        setError("Failed to fetch Product data.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getIdList();
  }, [id]);

  return (
    <Layout title="Product Variant View" content="container">
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Product Variant View</Block.Title>
          </Block.HeadContent>
          <Block.HeadContent>
            <ul className="d-flex">
              <li>
                <Link
                  to="/shop/admin/product-variant-list"
                  className="btn btn-primary btn-md d-md-none"
                >
                  <Icon name="arrow-long-left" />
                  <span>Go to List</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/shop/admin/product-variant-list"
                  className="btn btn-primary d-none d-md-inline-flex"
                >
                  <Icon name="arrow-long-left" />
                  <span>Go to List</span>
                </Link>
              </li>
            </ul>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block className="mt-4">
        <Card>
          <Card.Header>Product Variant Details</Card.Header>
          <Card.Body>
            {loading ? (
              <h1 className="d-flex justify-content-center align-items-center">
                Loading...
              </h1>
            ) : error ? (
              <h1 className="d-flex justify-content-center align-items-center text-danger">
                {error}
              </h1>
            ) : (
              <Row className="g-gs">
                <Col lg="12">
                  <table className="table small table-bordered">
                    <tbody>
                      {/* <tr>
                        <td style={styles.ctstyle}>Product:</td>
                        <td>{stateData.product_title}</td>
                      </tr> */}
                      <tr>
                        <td style={styles.ctstyle}>Product Variant Title:</td>
                        <td>{stateData.title}</td>
                      </tr>
                      <tr>
                        <td style={styles.ctstyle}>Product Variant Description:</td>
                        <td>{stateData.description}</td>
                      </tr>
                      <tr>
                        {/* <td style={styles.ctstyle}>Image:</td>
                        <td>
                          {stateData.image_url ? (
                            <img
                              src={stateData.image_url}
                              alt="Product Image"
                              style={{ width: "150px" }}
                            />
                          ) : (
                            "No Image Available"
                          )}
                        </td> */}
                      </tr>
                      <tr>
                        <td style={styles.ctstyle}>Price:</td>
                        <td>{stateData.price}</td>
                      </tr>
                      <tr>
                        <td style={styles.ctstyle}>Discount:</td>
                        <td>{stateData.discount}</td>
                      </tr>
                      <tr>
                        <td style={styles.ctstyle}>Unit ID:</td>
                        <td>{stateData.unit_id}</td>
                      </tr>
                      <tr>
                        <td style={styles.ctstyle}>Unit Quantity:</td>
                        <td>{stateData.unit_quantity}</td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
            )}
          </Card.Body>
        </Card>
      </Block>
    </Layout>
  );
}

export default ProductView;
